// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#AdminOpsAppearance {
  justify-content: flex-start;
}
#AdminOpsAppearance .ops-appearance-body {
  width: 100%;
  height: calc(100vh - var(--page-header-height));
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  padding: 0 16px 60px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
#AdminOpsAppearance .ops-appearance-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  row-gap: 8px;
}
#AdminOpsAppearance .ops-appearance-toolbar .ops-appearance-count {
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 1px;
}
#AdminOpsAppearance .ops-appearance-toolbar .ops-appearance-toolbar-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
#AdminOpsAppearance .ops-appearance-toolbar .ops-appearance-toolbar-actions .bi-arrow-clockwise {
  font-size: 14px;
}
#AdminOpsAppearance .ops-appearance-toolbar .ops-appearance-toolbar-actions .bi-plus {
  font-size: 16px;
}
#AdminOpsAppearance .ops-appearance-loading, #AdminOpsAppearance .ops-appearance-empty {
  display: flex;
  justify-content: center;
  padding: 32px;
  color: var(--dark-color-main);
}
#AdminOpsAppearance .ops-appearance-card {
  background: var(--white-color-lightest);
  border-radius: 8px;
  padding: 12px 16px 12px 12px;
  box-sizing: border-box;
  border-left: 4px solid var(--border-weak-color);
}
#AdminOpsAppearance .ops-appearance-card.is-use {
  border-left-color: var(--primary-color-main);
}
#AdminOpsAppearance .ops-appearance-head {
  display: flex;
  align-items: center;
  gap: 12px;
}
#AdminOpsAppearance .ops-appearance-toggle {
  flex: 1 1;
  min-width: 0;
  display: flex;
  align-items: center;
  padding: 0;
  border: none;
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
}
#AdminOpsAppearance .ops-appearance-chevron {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--dark-color-main);
}
#AdminOpsAppearance .ops-appearance-chevron .bi {
  font-size: 13px;
  transition: transform 0.2s;
}
#AdminOpsAppearance .ops-appearance-chevron .bi.is-open {
  transform: rotate(90deg);
}
#AdminOpsAppearance .ops-appearance-thumb {
  position: relative;
  height: 45px;
  width: 80px;
  margin-right: 12px;
  flex-shrink: 0;
  border-radius: 5px;
  overflow: hidden;
  box-sizing: border-box;
  border: 1px solid var(--ops-line);
  background: repeating-linear-gradient(45deg, #eef0f3 0 5px, #e2e5ea 5px 10px);
  transition: width 0.25s ease, margin-right 0.25s ease, opacity 0.2s, border-width 0.25s;
}
#AdminOpsAppearance .ops-appearance-thumb video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: var(--white-color-main);
  display: block;
}
#AdminOpsAppearance .ops-appearance-thumb.is-hidden {
  width: 0;
  margin-right: 0;
  border-width: 0;
  opacity: 0;
}
#AdminOpsAppearance .ops-appearance-info {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
#AdminOpsAppearance .ops-appearance-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
#AdminOpsAppearance .ops-appearance-name {
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  word-break: break-word;
}
#AdminOpsAppearance .ops-appearance-meta {
  font-size: 12px;
  line-height: 18px;
  color: var(--dark-color-main);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 6px;
}
#AdminOpsAppearance .ops-appearance-meta .ops-appearance-meta-sep {
  color: #d0d4db;
}
#AdminOpsAppearance .ops-appearance-edit {
  padding: 0 14px;
}
#AdminOpsAppearance .ops-appearance-download .bi {
  font-size: 13px;
}
#AdminOpsAppearance .ops-appearance-download:disabled {
  opacity: 0.5;
  cursor: default;
  pointer-events: none;
}
#AdminOpsAppearance .ops-appearance-videos {
  padding: 12px 0 4px 32px;
  box-sizing: border-box;
  display: flex;
  align-items: stretch;
  gap: 16px;
  flex-wrap: wrap;
  row-gap: 14px;
}
#AdminOpsAppearance .ops-appearance-video-group {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
#AdminOpsAppearance .ops-appearance-video-group.is-main {
  flex: 5 1 480px;
}
#AdminOpsAppearance .ops-appearance-video-group.is-widget {
  flex: 1 1 130px;
  max-width: 200px;
}
#AdminOpsAppearance .ops-appearance-video-title {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 1px;
  color: var(--dark-color-main);
}
#AdminOpsAppearance .ops-appearance-video-divider {
  width: 1px;
  background: var(--ops-line);
  flex-shrink: 0;
}
#AdminOpsAppearance .ops-appearance-video-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
  gap: 14px 12px;
}
#AdminOpsAppearance .ops-appearance-video-grid.is-single {
  grid-template-columns: minmax(0, 1fr);
}
#AdminOpsAppearance .ops-video-cell {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
}
#AdminOpsAppearance .ops-video-cell-head {
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
  height: 16px;
}
#AdminOpsAppearance .ops-video-cell-head .ops-video-cell-label {
  font-size: 12px;
  font-weight: 700;
  font-family: var(--ops-mono);
  white-space: nowrap;
}
#AdminOpsAppearance .ops-video-cell-head .ops-video-cell-label.is-empty {
  color: var(--font_active_sub_color);
}
#AdminOpsAppearance .ops-video-cell-head .ops-video-cell-jp {
  min-width: 0;
  font-size: 11px;
  color: var(--disabled-font-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
#AdminOpsAppearance .ops-video-cell-path {
  font-size: 10.5px;
  color: var(--font_active_sub_color);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#AdminOpsAppearance .ops-video-empty {
  width: 100%;
  aspect-ratio: 16/9;
  border-radius: 6px;
  border: 1px dashed var(--border-weak-color);
  background: var(--input-bg-color);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  color: var(--input-placeholder-color);
}
#AdminOpsAppearance .ops-video-empty span {
  font-size: 11px;
}

.ops-scope .ops-video-tile {
  position: relative;
  width: 100%;
  aspect-ratio: 16/9;
  border-radius: 6px;
  overflow: hidden;
  background: repeating-linear-gradient(45deg, #eef0f3 0 5px, #e2e5ea 5px 10px);
  cursor: pointer;
}
.ops-scope .ops-video-tile video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: var(--white-color-main);
  display: block;
}
.ops-scope .ops-video-loading {
  position: absolute;
  inset: 0;
  z-index: 1;
  background: #eef0f3;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: var(--disabled-font-color);
  font-size: 10px;
}
.ops-scope .ops-video-loading .bi {
  font-size: 14px;
}
.ops-scope .ops-video-play {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.ops-scope .ops-video-play span {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.8509803922);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--dark-color-dark);
}
.ops-scope .ops-video-play span .bi {
  font-size: 15px;
}
.ops-scope .ops-video-open {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 2;
  width: 22px;
  height: 22px;
  min-height: 22px;
  padding: 0;
  border-radius: 4px;
  border: none;
  background: rgba(255, 255, 255, 0.8509803922);
  color: var(--dark-color-main);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ops-scope .ops-video-open .bi {
  font-size: 11px;
}
.ops-scope .ops-video-open:hover {
  background: var(--white-color-lightest);
  color: var(--dark-color-dark);
}
.ops-scope .ops-form-card.is-roomy {
  gap: 20px;
}
.ops-scope .ops-form-card.is-edit {
  padding: 24px 24px 14px;
}
.ops-scope .ops-form-field {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.ops-scope .ops-field-title {
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 1px;
}
.ops-scope .ops-field-title-row {
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
}
.ops-scope .ops-field-sub {
  font-size: 11px;
  color: var(--font_active_sub_color);
}
.ops-scope .ops-field-desc {
  font-size: 12px;
  line-height: 1.7;
  color: var(--dark-color-main);
}
.ops-scope .ops-field-desc.is-warn {
  color: var(--ops-draft-fg);
  font-weight: 600;
}
.ops-scope .ops-voice-row {
  display: flex;
  gap: 8px;
}
.ops-scope .ops-voice-row .ops-select {
  flex: 1 1;
  min-width: 0;
}
.ops-scope .ops-voice-play {
  width: 44px;
  height: 40px;
  min-height: 40px;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid var(--border-color);
  background: var(--white-color-lightest);
  color: var(--dark-color-main);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ops-scope .ops-voice-play .bi {
  font-size: 18px;
}
.ops-scope .ops-voice-play:hover {
  background: var(--dark-color-dark-transparent-10);
}
.ops-scope .ops-voice-play:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.ops-scope .ops-required-mark {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0;
  color: var(--primary-color-main);
}
.ops-scope .ops-auto-mini-toggle:has(input:disabled) {
  color: var(--font_active_sub_color);
  cursor: default;
}
.ops-scope .ops-upload-progress {
  flex: 1 1;
  min-width: 200px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 12px;
  color: var(--dark-color-main);
}
.ops-scope .ops-upload-progress .progress-bar {
  flex: 1 1;
}
.ops-scope .ops-upload-submit {
  min-width: 200px;
}
.ops-scope .ops-edit-basic {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
  align-items: start;
}
.ops-scope .ops-edit-basic .ops-field-title, .ops-scope .ops-edit-basic .ops-field-title-row {
  line-height: 18px;
}
.ops-scope .ops-video-slots {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ops-scope .ops-edit-pending {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 20px;
  font-size: 12px;
  color: var(--font_active_sub_color);
}
.ops-scope .ops-edit-clear-all {
  margin-left: auto;
  height: 24px;
  min-height: 24px;
  padding: 0 10px;
  border: none;
  border-radius: 12px;
  background: transparent;
  color: var(--font_active_sub_color);
  font-family: inherit;
  font-size: 11px;
  text-decoration: underline;
  cursor: pointer;
}
.ops-scope .ops-edit-clear-all:hover {
  color: var(--dark-color-dark);
}
.ops-scope .ops-video-slot {
  position: relative;
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr) auto;
  align-items: center;
  column-gap: 16px;
  padding: 12px 14px;
  border-radius: 8px;
  border: 1px solid var(--ops-line);
  background: var(--white-color-lightest);
  transition: background-color 0.15s, border-color 0.15s;
}
.ops-scope .ops-video-slot.has-file {
  background: #fff7f8;
  border-color: #f6b9c4;
}
.ops-scope .ops-video-slot.is-over {
  border: 1px dashed var(--primary-color-main);
}
.ops-scope .ops-video-slot-label {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
  word-break: break-word;
}
.ops-scope .ops-video-slot-label-main {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  column-gap: 6px;
  font-size: 13px;
  font-weight: 700;
  line-height: 18px;
}
.ops-scope .ops-video-slot-label-sub {
  font-size: 11px;
  font-weight: 500;
  line-height: 15px;
  color: var(--dark-color-main);
}
.ops-scope .ops-video-slot-change {
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 20px minmax(0, 1.2fr);
  align-items: center;
  column-gap: 8px;
}
.ops-scope .ops-video-slot-col {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.ops-scope .ops-video-slot-cap {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1px;
  color: #838996;
}
.ops-scope .ops-video-slot-cap.is-new {
  color: var(--primary-color-dark);
}
.ops-scope .ops-video-slot-path {
  min-width: 0;
  font-family: var(--ops-mono);
  font-size: 12px;
  color: var(--dark-color-dark);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ops-scope .ops-video-slot-path.is-empty {
  color: var(--font_active_sub_color);
}
.ops-scope .ops-video-slot-path.is-old {
  color: #838996;
}
.ops-scope .ops-video-slot-path.is-replaced {
  text-decoration: line-through;
}
.ops-scope .ops-video-slot-path.is-new {
  font-weight: 700;
}
.ops-scope .ops-video-slot-new {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}
.ops-scope .ops-video-slot-thumb {
  width: 64px;
  height: 64px;
  flex-shrink: 0;
  border-radius: 6px;
  object-fit: contain;
  background: var(--white-color-main);
  border: 1px solid var(--ops-line);
  box-sizing: border-box;
}
.ops-scope .ops-video-slot-thumb.is-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--disabled-font-color);
  font-size: 20px;
}
.ops-scope .ops-video-slot-arrow {
  justify-self: center;
  font-size: 14px;
  color: var(--primary-color-main);
}
.ops-scope .ops-video-slot-actions {
  justify-self: end;
  display: flex;
  align-items: center;
  gap: 6px;
}
.ops-scope .ops-video-slot-pick {
  height: 30px;
  min-height: 30px;
  border-radius: 15px;
  gap: 5px;
}
.ops-scope .ops-video-slot-pick .bi {
  font-size: 12px;
}
.ops-scope .ops-video-slot-clear {
  width: 30px;
  height: 30px;
  min-height: 30px;
  padding: 0;
  border-radius: 50%;
  border: 1px solid var(--border-weak-color);
  background: var(--white-color-lightest);
  color: var(--font_active_sub_color);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.ops-scope .ops-video-slot-clear .bi {
  font-size: 12px;
}
.ops-scope .ops-video-slot-clear:hover {
  background: var(--dark-color-dark-transparent-10);
  color: var(--dark-color-dark);
}
.ops-scope .ops-video-slot-note {
  grid-column: 2/-1;
  margin-top: 8px;
}
.ops-scope .ops-video-slot-mini {
  grid-column: 2/-1;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed #f0cdd4;
}
.ops-scope .ops-video-slot-hint {
  position: absolute;
  inset: 0;
  border-radius: 8px;
  background: rgba(253, 238, 241, 0.9019607843);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 700;
  color: var(--primary-color-dark);
  pointer-events: none;
}
.ops-scope .ops-video-slot-hint .bi {
  font-size: 16px;
}
.ops-scope .ops-voice-preview-body {
  background: var(--white-color-lightest);
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.ops-scope .ops-voice-generate {
  font-size: 14px;
  letter-spacing: 1px;
  padding: 8px 20px;
}
.ops-scope .ops-voice-generate .bi {
  font-size: 18px;
}
.ops-scope .ops-audio-bar {
  height: 44px;
  border-radius: 8px;
  background: var(--input-bg-color);
  border: 1px solid var(--ops-line);
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 14px;
  box-sizing: border-box;
  color: var(--font_active_sub_color);
}
.ops-scope .ops-audio-bar.is-ready {
  color: var(--dark-color-main);
}
.ops-scope .ops-audio-toggle {
  border: none;
  background: transparent;
  padding: 0;
  color: inherit;
  cursor: pointer;
}
.ops-scope .ops-audio-toggle .bi {
  font-size: 20px;
}
.ops-scope .ops-audio-toggle:disabled {
  cursor: default;
}
.ops-scope .ops-audio-track {
  flex: 1 1;
  height: 4px;
  border-radius: 2px;
  background: #e2e5ea;
  overflow: hidden;
}
.ops-scope .ops-audio-progress {
  height: 100%;
  background: var(--primary-color-main);
}
.ops-scope .ops-audio-time {
  font-size: 11px;
  font-family: var(--ops-mono);
}
.ops-scope .ops-optimize {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 12px;
  font-size: 11px;
}
.ops-scope .ops-optimize-state {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  color: var(--font_active_sub_color);
}
.ops-scope .ops-optimize-state.is-busy {
  color: var(--dark-color-main);
}
.ops-scope .ops-optimize-state.is-done {
  color: var(--ops-inuse-fg);
}
.ops-scope .ops-optimize-skip {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
  color: var(--dark-color-main);
  cursor: pointer;
}
.ops-scope .ops-optimize-skip input {
  margin: 0;
  cursor: pointer;
}
.ops-scope .ops-auto-mini-badge {
  width: fit-content;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 1px 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0;
  background: #eef0f3;
  color: var(--font_active_sub_color);
}
.ops-scope .ops-auto-mini-badge .bi {
  font-size: 10px;
}
.ops-scope .ops-auto-mini-badge.is-small {
  gap: 3px;
  padding: 0 6px;
  font-size: 9.5px;
  line-height: 15px;
}
.ops-scope .ops-auto-mini-badge.is-small .bi {
  font-size: 9px;
}
.ops-scope .ops-auto-mini-toggle {
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11.5px;
  color: var(--dark-color-dark);
  cursor: pointer;
}
.ops-scope .ops-auto-mini-toggle input {
  margin: 0;
  accent-color: var(--primary-color-main);
  cursor: pointer;
}
.ops-scope .ops-spin {
  animation: ops-spin 1s linear infinite;
}

@keyframes ops-spin {
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/admin/parts/ops/AdminOpsAppearance.scss"],"names":[],"mappings":"AACA;EACI,2BAAA;AAAJ;AAEI;EACI,WAAA;EACA,+CAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAAR;AAGI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,YAAA;AADR;AAGQ;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AADZ;AAGQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AADZ;AAGY;EAAsB,eAAA;AAAlC;AACY;EAAW,eAAA;AAEvB;AAEI;EACI,aAAA;EACA,uBAAA;EACA,aAAA;EACA,6BAAA;AAAR;AAGI;EACI,uCAAA;EACA,kBAAA;EACA,4BAAA;EACA,sBAAA;EACA,+CAAA;AADR;AAGQ;EACI,4CAAA;AADZ;AAKI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAHR;AAMI;EACI,SAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAJR;AAOI;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AALR;AAOQ;EACI,eAAA;EACA,0BAAA;AALZ;AAOY;EAAY,wBAAA;AAJxB;AAQI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iCAAA;EACA,6EAAA;EACA,uFAAA;AANR;AASQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mCAAA;EACA,cAAA;AAPZ;AAUQ;EACI,QAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;AARZ;AAYI;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAVR;AAaI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAXR;AAcI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AAZR;AAeI;EACI,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;AAbR;AAeQ;EAA2B,cAAA;AAZnC;AAeI;EACI,eAAA;AAbR;AAiBQ;EAAM,eAAA;AAdd;AAgBQ;EACI,YAAA;EACA,eAAA;EACA,oBAAA;AAdZ;AAkBI;EACI,wBAAA;EACA,sBAAA;EACA,aAAA;EACA,oBAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;AAhBR;AAmBI;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAjBR;AAmBQ;EAAY,eAAA;AAhBpB;AAiBQ;EAAc,eAAA;EAAiB,gBAAA;AAbvC;AAgBI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;AAdR;AAiBI;EACI,UAAA;EACA,2BAAA;EACA,cAAA;AAfR;AAkBI;EACI,aAAA;EACA,2DAAA;EACA,cAAA;AAhBR;AAkBQ;EAAc,qCAAA;AAftB;AAkBI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAhBR;AAmBI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;AAjBR;AAmBQ;EACI,eAAA;EACA,gBAAA;EACA,4BAAA;EACA,mBAAA;AAjBZ;AAmBY;EAAa,mCAAA;AAhBzB;AAkBQ;EACI,YAAA;EACA,eAAA;EACA,iCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAhBZ;AAoBI;EACI,iBAAA;EACA,mCAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAlBR;AAqBI;EACI,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,2CAAA;EACA,iCAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,qCAAA;AAnBR;AAqBQ;EAAO,eAAA;AAlBf;;AAwBI;EACI,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6EAAA;EACA,eAAA;AArBR;AAwBQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mCAAA;EACA,cAAA;AAtBZ;AA0BI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iCAAA;EACA,eAAA;AAxBR;AA0BQ;EAAM,eAAA;AAvBd;AA0BI;EACI,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;AAxBR;AA0BQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AAxBZ;AA0BY;EAAM,eAAA;AAvBlB;AA2BI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,6CAAA;EACA,6BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAzBR;AA2BQ;EAAM,eAAA;AAxBd;AA0BQ;EACI,uCAAA;EACA,6BAAA;AAxBZ;AA+BI;EACI,SAAA;AA7BR;AAgCI;EACI,uBAAA;AA9BR;AAiCI;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA/BR;AAkCI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AAhCR;AAmCI;EACI,aAAA;EACA,qBAAA;EACA,QAAA;EACA,eAAA;AAjCR;AAoCI;EACI,eAAA;EACA,mCAAA;AAlCR;AAqCI;EACI,eAAA;EACA,gBAAA;EACA,6BAAA;AAnCR;AAqCQ;EAAY,0BAAA;EAA4B,gBAAA;AAjChD;AAoCI;EACI,aAAA;EACA,QAAA;AAlCR;AAoCQ;EACI,SAAA;EACA,YAAA;AAlCZ;AAsCI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,qCAAA;EACA,uCAAA;EACA,6BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AApCR;AAsCQ;EAAM,eAAA;AAnCd;AAqCQ;EAAU,iDAAA;AAlClB;AAmCQ;EAAa,YAAA;EAAa,mBAAA;AA/BlC;AAkCI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCAAA;AAhCR;AAmCI;EAA4C,mCAAA;EAAqC,eAAA;AA/BrF;AAiCI;EACI,SAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,6BAAA;AA/BR;AAiCQ;EAAgB,SAAA;AA9BxB;AAiCI;EACI,gBAAA;AA/BR;AAmCI;EACI,aAAA;EACA,2DAAA;EACA,SAAA;EACA,kBAAA;AAjCR;AAmCQ;EAAyC,iBAAA;AAhCjD;AAoCI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AAlCR;AAqCI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,mCAAA;AAnCR;AAsCI;EACI,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,mCAAA;EACA,oBAAA;EACA,eAAA;EACA,0BAAA;EACA,eAAA;AApCR;AAsCQ;EAAU,6BAAA;AAnClB;AAsCI;EACI,kBAAA;EACA,aAAA;EACA,gDAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iCAAA;EACA,uCAAA;EACA,sDAAA;AApCR;AAsCQ;EACI,mBAAA;EACA,qBAAA;AApCZ;AAuCQ;EAAY,4CAAA;AApCpB;AAwCI;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,sBAAA;AAtCR;AAyCI;EACI,aAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAvCR;AA0CI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AAxCR;AA2CI;EACI,YAAA;EACA,aAAA;EACA,2DAAA;EACA,mBAAA;EACA,eAAA;AAzCR;AA4CI;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA1CR;AA6CI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AA3CR;AA6CQ;EAAW,gCAAA;AA1CnB;AA6CI;EACI,YAAA;EACA,4BAAA;EACA,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA3CR;AA6CQ;EAAa,mCAAA;AA1CrB;AA2CQ;EAAW,cAAA;AAxCnB;AAyCQ;EAAgB,6BAAA;AAtCxB;AAwCQ;EAAW,gBAAA;AArCnB;AAyCI;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAvCR;AA2CI;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,mCAAA;EACA,iCAAA;EACA,sBAAA;AAzCR;AA2CQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,eAAA;AAzCZ;AA6CI;EACI,oBAAA;EACA,eAAA;EACA,gCAAA;AA3CR;AA8CI;EACI,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA5CR;AA+CI;EACI,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,QAAA;AA7CR;AA+CQ;EAAM,eAAA;AA5Cd;AA+CI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,0CAAA;EACA,uCAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AA7CR;AA+CQ;EAAM,eAAA;AA5Cd;AA8CQ;EACI,iDAAA;EACA,6BAAA;AA5CZ;AAiDI;EACI,iBAAA;EACA,eAAA;AA/CR;AAkDI;EACI,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;AAhDR;AAmDI;EACI,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,6CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,oBAAA;AAjDR;AAmDQ;EAAM,eAAA;AAhDd;AAoDI;EACI,uCAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAlDR;AAqDI;EACI,eAAA;EACA,mBAAA;EACA,iBAAA;AAnDR;AAqDQ;EAAM,eAAA;AAlDd;AAqDI;EACI,YAAA;EACA,kBAAA;EACA,iCAAA;EACA,iCAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,sBAAA;EACA,mCAAA;AAnDR;AAqDQ;EAAa,6BAAA;AAlDrB;AAqDI;EACI,YAAA;EACA,uBAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;AAnDR;AAqDQ;EAAM,eAAA;AAlDd;AAmDQ;EAAa,eAAA;AAhDrB;AAmDI;EACI,SAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAjDR;AAoDI;EACI,YAAA;EACA,qCAAA;AAlDR;AAqDI;EACI,eAAA;EACA,4BAAA;AAnDR;AAuDI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;AArDR;AAwDI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,mCAAA;AAtDR;AAwDQ;EAAY,6BAAA;AArDpB;AAsDQ;EAAY,0BAAA;AAnDpB;AAsDI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,6BAAA;EACA,eAAA;AApDR;AAsDQ;EAAQ,SAAA;EAAW,eAAA;AAlD3B;AAsDI;EACI,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mCAAA;AApDR;AAsDQ;EAAM,eAAA;AAnDd;AAqDQ;EACI,QAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AAnDZ;AAqDY;EAAM,cAAA;AAlDlB;AAsDI;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,6BAAA;EACA,eAAA;AApDR;AAsDQ;EAAQ,SAAA;EAAW,uCAAA;EAAyC,eAAA;AAjDpE;AAoDI;EAAY,sCAAA;AAjDhB;;AAoDA;EACI;IAAK,yBAAA;EAhDP;AACF","sourcesContent":["// 外見動画管理（デザイン PRizmo_Admin.dc.html L2391-2804）\n#AdminOpsAppearance {\n    justify-content: flex-start;\n\n    .ops-appearance-body {\n        width: 100%;\n        height: calc(100vh - var(--page-header-height));\n        overflow-y: auto;\n        overflow-x: hidden;\n        box-sizing: border-box;\n        padding: 0 16px 60px;\n        display: flex;\n        flex-direction: column;\n        gap: 16px;\n    }\n\n    .ops-appearance-toolbar {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 16px;\n        flex-wrap: wrap;\n        row-gap: 8px;\n\n        .ops-appearance-count {\n            font-size: 14px;\n            font-weight: 800;\n            letter-spacing: 1px;\n        }\n        .ops-appearance-toolbar-actions {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n\n            .bi-arrow-clockwise { font-size: 14px; }\n            .bi-plus { font-size: 16px; }\n        }\n    }\n\n    .ops-appearance-loading, .ops-appearance-empty {\n        display: flex;\n        justify-content: center;\n        padding: 32px;\n        color: var(--dark-color-main);\n    }\n\n    .ops-appearance-card {\n        background: var(--white-color-lightest);\n        border-radius: 8px;\n        padding: 12px 16px 12px 12px;\n        box-sizing: border-box;\n        border-left: 4px solid var(--border-weak-color);\n\n        &.is-use {\n            border-left-color: var(--primary-color-main);\n        }\n    }\n\n    .ops-appearance-head {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n    }\n\n    .ops-appearance-toggle {\n        flex: 1;\n        min-width: 0;\n        display: flex;\n        align-items: center;\n        padding: 0;\n        border: none;\n        background: transparent;\n        color: inherit;\n        text-align: left;\n        cursor: pointer;\n    }\n\n    .ops-appearance-chevron {\n        width: 20px;\n        height: 20px;\n        flex-shrink: 0;\n        margin-right: 12px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        color: var(--dark-color-main);\n\n        .bi {\n            font-size: 13px;\n            transition: transform .2s;\n\n            &.is-open { transform: rotate(90deg); }\n        }\n    }\n\n    .ops-appearance-thumb {\n        position: relative;\n        height: 45px;\n        width: 80px;\n        margin-right: 12px;\n        flex-shrink: 0;\n        border-radius: 5px;\n        overflow: hidden;\n        box-sizing: border-box;\n        border: 1px solid var(--ops-line);\n        background: repeating-linear-gradient(45deg, #eef0f3 0 5px, #e2e5ea 5px 10px);\n        transition: width .25s ease, margin-right .25s ease, opacity .2s, border-width .25s;\n\n        // 縦長の動画も切らずに枠内へ収める（余白は無地にする）\n        video {\n            width: 100%;\n            height: 100%;\n            object-fit: contain;\n            background: var(--white-color-main);\n            display: block;\n        }\n\n        &.is-hidden {\n            width: 0;\n            margin-right: 0;\n            border-width: 0;\n            opacity: 0;\n        }\n    }\n\n    .ops-appearance-info {\n        min-width: 0;\n        display: flex;\n        flex-direction: column;\n        gap: 2px;\n    }\n\n    .ops-appearance-name-row {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        min-width: 0;\n    }\n\n    .ops-appearance-name {\n        font-size: 14px;\n        font-weight: 700;\n        line-height: 20px;\n        word-break: break-word;\n    }\n\n    .ops-appearance-meta {\n        font-size: 12px;\n        line-height: 18px;\n        color: var(--dark-color-main);\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        column-gap: 6px;\n\n        .ops-appearance-meta-sep { color: #d0d4db; }\n    }\n\n    .ops-appearance-edit {\n        padding: 0 14px;\n    }\n\n    .ops-appearance-download {\n        .bi { font-size: 13px; }\n\n        &:disabled {\n            opacity: .5;\n            cursor: default;\n            pointer-events: none;\n        }\n    }\n\n    .ops-appearance-videos {\n        padding: 12px 0 4px 32px;\n        box-sizing: border-box;\n        display: flex;\n        align-items: stretch;\n        gap: 16px;\n        flex-wrap: wrap;\n        row-gap: 14px;\n    }\n\n    .ops-appearance-video-group {\n        min-width: 0;\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n\n        &.is-main { flex: 5 1 480px; }\n        &.is-widget { flex: 1 1 130px; max-width: 200px; }\n    }\n\n    .ops-appearance-video-title {\n        font-size: 11px;\n        font-weight: 800;\n        letter-spacing: 1px;\n        color: var(--dark-color-main);\n    }\n\n    .ops-appearance-video-divider {\n        width: 1px;\n        background: var(--ops-line);\n        flex-shrink: 0;\n    }\n\n    .ops-appearance-video-grid {\n        display: grid;\n        grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));\n        gap: 14px 12px;\n\n        &.is-single { grid-template-columns: minmax(0, 1fr); }\n    }\n\n    .ops-video-cell {\n        display: flex;\n        flex-direction: column;\n        gap: 5px;\n        min-width: 0;\n    }\n\n    .ops-video-cell-head {\n        display: flex;\n        align-items: center;\n        gap: 5px;\n        min-width: 0;\n        height: 16px;\n\n        .ops-video-cell-label {\n            font-size: 12px;\n            font-weight: 700;\n            font-family: var(--ops-mono);\n            white-space: nowrap;\n\n            &.is-empty { color: var(--font_active_sub_color); }\n        }\n        .ops-video-cell-jp {\n            min-width: 0;\n            font-size: 11px;\n            color: var(--disabled-font-color);\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n        }\n    }\n\n    .ops-video-cell-path {\n        font-size: 10.5px;\n        color: var(--font_active_sub_color);\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n\n    .ops-video-empty {\n        width: 100%;\n        aspect-ratio: 16 / 9;\n        border-radius: 6px;\n        border: 1px dashed var(--border-weak-color);\n        background: var(--input-bg-color);\n        box-sizing: border-box;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        gap: 2px;\n        color: var(--input-placeholder-color);\n\n        span { font-size: 11px; }\n    }\n}\n\n// 動画プレビュー（一覧・モーダル共通）\n.ops-scope {\n    .ops-video-tile {\n        position: relative;\n        width: 100%;\n        aspect-ratio: 16 / 9;\n        border-radius: 6px;\n        overflow: hidden;\n        background: repeating-linear-gradient(45deg, #eef0f3 0 5px, #e2e5ea 5px 10px);\n        cursor: pointer;\n\n        // 縦長の動画も切らずに枠内へ収める（余白は無地にする）\n        video {\n            width: 100%;\n            height: 100%;\n            object-fit: contain;\n            background: var(--white-color-main);\n            display: block;\n        }\n    }\n\n    .ops-video-loading {\n        position: absolute;\n        inset: 0;\n        z-index: 1;\n        background: #eef0f3;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        gap: 4px;\n        color: var(--disabled-font-color);\n        font-size: 10px;\n\n        .bi { font-size: 14px; }\n    }\n\n    .ops-video-play {\n        position: absolute;\n        inset: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        pointer-events: none;\n\n        span {\n            width: 28px;\n            height: 28px;\n            border-radius: 50%;\n            background: #ffffffd9;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            color: var(--dark-color-dark);\n\n            .bi { font-size: 15px; }\n        }\n    }\n\n    .ops-video-open {\n        position: absolute;\n        top: 5px;\n        right: 5px;\n        z-index: 2;\n        width: 22px;\n        height: 22px;\n        min-height: 22px;\n        padding: 0;\n        border-radius: 4px;\n        border: none;\n        background: #ffffffd9;\n        color: var(--dark-color-main);\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        .bi { font-size: 11px; }\n\n        &:hover {\n            background: var(--white-color-lightest);\n            color: var(--dark-color-dark);\n        }\n    }\n\n    // ------------------------------------------------------------------\n    // 追加・編集モーダル\n    // ------------------------------------------------------------------\n    .ops-form-card.is-roomy {\n        gap: 20px;\n    }\n\n    .ops-form-card.is-edit {\n        padding: 24px 24px 14px;\n    }\n\n    .ops-form-field {\n        min-width: 0;\n        display: flex;\n        flex-direction: column;\n        gap: 6px;\n    }\n\n    .ops-field-title {\n        font-size: 12px;\n        font-weight: 800;\n        letter-spacing: 1px;\n    }\n\n    .ops-field-title-row {\n        display: flex;\n        align-items: baseline;\n        gap: 8px;\n        flex-wrap: wrap;\n    }\n\n    .ops-field-sub {\n        font-size: 11px;\n        color: var(--font_active_sub_color);\n    }\n\n    .ops-field-desc {\n        font-size: 12px;\n        line-height: 1.7;\n        color: var(--dark-color-main);\n\n        &.is-warn { color: var(--ops-draft-fg); font-weight: 600; }\n    }\n\n    .ops-voice-row {\n        display: flex;\n        gap: 8px;\n\n        .ops-select {\n            flex: 1;\n            min-width: 0;\n        }\n    }\n\n    .ops-voice-play {\n        width: 44px;\n        height: 40px;\n        min-height: 40px;\n        flex-shrink: 0;\n        border-radius: 8px;\n        border: 1px solid var(--border-color);\n        background: var(--white-color-lightest);\n        color: var(--dark-color-main);\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        .bi { font-size: 18px; }\n\n        &:hover { background: var(--dark-color-dark-transparent-10); }\n        &:disabled { opacity: .5; cursor: not-allowed; }\n    }\n\n    .ops-required-mark {\n        font-size: 11px;\n        font-weight: 600;\n        letter-spacing: 0;\n        color: var(--primary-color-main);\n    }\n\n    .ops-auto-mini-toggle:has(input:disabled) { color: var(--font_active_sub_color); cursor: default; }\n\n    .ops-upload-progress {\n        flex: 1;\n        min-width: 200px;\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        font-size: 12px;\n        color: var(--dark-color-main);\n\n        .progress-bar { flex: 1; }\n    }\n\n    .ops-upload-submit {\n        min-width: 200px;\n    }\n\n    // 名前・ボイス（横に並べ、狭いときは縦に積む）\n    .ops-edit-basic {\n        display: grid;\n        grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n        gap: 16px;\n        align-items: start;\n\n        .ops-field-title, .ops-field-title-row { line-height: 18px; }\n    }\n\n    // 動画行（追加・編集で共通。1種別1枚のカード。編集で添付すると「現在 → 差し替え後」を並べる）\n    .ops-video-slots {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n    }\n\n    .ops-edit-pending {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        min-height: 20px;\n        font-size: 12px;\n        color: var(--font_active_sub_color);\n    }\n\n    .ops-edit-clear-all {\n        margin-left: auto;\n        height: 24px;\n        min-height: 24px;\n        padding: 0 10px;\n        border: none;\n        border-radius: 12px;\n        background: transparent;\n        color: var(--font_active_sub_color);\n        font-family: inherit;\n        font-size: 11px;\n        text-decoration: underline;\n        cursor: pointer;\n\n        &:hover { color: var(--dark-color-dark); }\n    }\n\n    .ops-video-slot {\n        position: relative;\n        display: grid;\n        grid-template-columns: 150px minmax(0, 1fr) auto;\n        align-items: center;\n        column-gap: 16px;\n        padding: 12px 14px;\n        border-radius: 8px;\n        border: 1px solid var(--ops-line);\n        background: var(--white-color-lightest);\n        transition: background-color .15s, border-color .15s;\n\n        &.has-file {\n            background: #fff7f8;\n            border-color: #f6b9c4;\n        }\n\n        &.is-over { border: 1px dashed var(--primary-color-main); }\n    }\n\n    // 1行目に種別名（＋必須）、2行目に括弧内の説明\n    .ops-video-slot-label {\n        min-width: 0;\n        display: flex;\n        flex-direction: column;\n        gap: 1px;\n        word-break: break-word;\n    }\n\n    .ops-video-slot-label-main {\n        display: flex;\n        flex-wrap: wrap;\n        align-items: baseline;\n        column-gap: 6px;\n        font-size: 13px;\n        font-weight: 700;\n        line-height: 18px;\n    }\n\n    .ops-video-slot-label-sub {\n        font-size: 11px;\n        font-weight: 500;\n        line-height: 15px;\n        color: var(--dark-color-main);\n    }\n\n    .ops-video-slot-change {\n        min-width: 0;\n        display: grid;\n        grid-template-columns: minmax(0, 1fr) 20px minmax(0, 1.2fr);\n        align-items: center;\n        column-gap: 8px;\n    }\n\n    .ops-video-slot-col {\n        min-width: 0;\n        display: flex;\n        flex-direction: column;\n        gap: 2px;\n    }\n\n    .ops-video-slot-cap {\n        display: flex;\n        align-items: center;\n        gap: 6px;\n        font-size: 10px;\n        font-weight: 700;\n        letter-spacing: 1px;\n        color: #838996;\n\n        &.is-new { color: var(--primary-color-dark); }\n    }\n\n    .ops-video-slot-path {\n        min-width: 0;\n        font-family: var(--ops-mono);\n        font-size: 12px;\n        color: var(--dark-color-dark);\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n\n        &.is-empty { color: var(--font_active_sub_color); }\n        &.is-old { color: #838996; }\n        &.is-replaced { text-decoration: line-through; }\n\n        &.is-new { font-weight: 700; }\n    }\n\n    // 添付したファイル（サムネイル＋名前）\n    .ops-video-slot-new {\n        min-width: 0;\n        display: flex;\n        align-items: center;\n        gap: 10px;\n    }\n\n    // 縦長・横長とも枠内に収める（余白は無地）\n    .ops-video-slot-thumb {\n        width: 64px;\n        height: 64px;\n        flex-shrink: 0;\n        border-radius: 6px;\n        object-fit: contain;\n        background: var(--white-color-main);\n        border: 1px solid var(--ops-line);\n        box-sizing: border-box;\n\n        &.is-empty {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            color: var(--disabled-font-color);\n            font-size: 20px;\n        }\n    }\n\n    .ops-video-slot-arrow {\n        justify-self: center;\n        font-size: 14px;\n        color: var(--primary-color-main);\n    }\n\n    .ops-video-slot-actions {\n        justify-self: end;\n        display: flex;\n        align-items: center;\n        gap: 6px;\n    }\n\n    .ops-video-slot-pick {\n        height: 30px;\n        min-height: 30px;\n        border-radius: 15px;\n        gap: 5px;\n\n        .bi { font-size: 12px; }\n    }\n\n    .ops-video-slot-clear {\n        width: 30px;\n        height: 30px;\n        min-height: 30px;\n        padding: 0;\n        border-radius: 50%;\n        border: 1px solid var(--border-weak-color);\n        background: var(--white-color-lightest);\n        color: var(--font_active_sub_color);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n\n        .bi { font-size: 12px; }\n\n        &:hover {\n            background: var(--dark-color-dark-transparent-10);\n            color: var(--dark-color-dark);\n        }\n    }\n\n    // 状態・注意・切り替えは中央の列の左端にそろえる\n    .ops-video-slot-note {\n        grid-column: 2 / -1;\n        margin-top: 8px;\n    }\n\n    .ops-video-slot-mini {\n        grid-column: 2 / -1;\n        margin-top: 8px;\n        padding-top: 8px;\n        border-top: 1px dashed #f0cdd4;\n    }\n\n    .ops-video-slot-hint {\n        position: absolute;\n        inset: 0;\n        border-radius: 8px;\n        background: #fdeef1e6;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 8px;\n        font-size: 12px;\n        font-weight: 700;\n        color: var(--primary-color-dark);\n        pointer-events: none;\n\n        .bi { font-size: 16px; }\n    }\n\n    // ボイスプレビュー\n    .ops-voice-preview-body {\n        background: var(--white-color-lightest);\n        display: flex;\n        flex-direction: column;\n        gap: 16px;\n    }\n\n    .ops-voice-generate {\n        font-size: 14px;\n        letter-spacing: 1px;\n        padding: 8px 20px;\n\n        .bi { font-size: 18px; }\n    }\n\n    .ops-audio-bar {\n        height: 44px;\n        border-radius: 8px;\n        background: var(--input-bg-color);\n        border: 1px solid var(--ops-line);\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        padding: 0 14px;\n        box-sizing: border-box;\n        color: var(--font_active_sub_color);\n\n        &.is-ready { color: var(--dark-color-main); }\n    }\n\n    .ops-audio-toggle {\n        border: none;\n        background: transparent;\n        padding: 0;\n        color: inherit;\n        cursor: pointer;\n\n        .bi { font-size: 20px; }\n        &:disabled { cursor: default; }\n    }\n\n    .ops-audio-track {\n        flex: 1;\n        height: 4px;\n        border-radius: 2px;\n        background: #e2e5ea;\n        overflow: hidden;\n    }\n\n    .ops-audio-progress {\n        height: 100%;\n        background: var(--primary-color-main);\n    }\n\n    .ops-audio-time {\n        font-size: 11px;\n        font-family: var(--ops-mono);\n    }\n\n    // 添付した動画の最適化の状態（ブラウザで変換）\n    .ops-optimize {\n        display: flex;\n        align-items: center;\n        flex-wrap: wrap;\n        gap: 6px 12px;\n        font-size: 11px;\n    }\n\n    .ops-optimize-state {\n        display: flex;\n        align-items: center;\n        gap: 6px;\n        font-weight: 600;\n        color: var(--font_active_sub_color);\n\n        &.is-busy { color: var(--dark-color-main); }\n        &.is-done { color: var(--ops-inuse-fg); }\n    }\n\n    .ops-optimize-skip {\n        display: flex;\n        align-items: center;\n        gap: 4px;\n        margin-left: auto;\n        color: var(--dark-color-main);\n        cursor: pointer;\n\n        input { margin: 0; cursor: pointer; }\n    }\n\n    // idle から作ったウィジェット表示動画の目印と、作るかの切り替え\n    .ops-auto-mini-badge {\n        width: fit-content;\n        display: inline-flex;\n        align-items: center;\n        gap: 4px;\n        padding: 1px 8px;\n        border-radius: 999px;\n        font-size: 10px;\n        font-weight: 700;\n        line-height: 16px;\n        letter-spacing: 0;\n        background: #eef0f3;\n        color: var(--font_active_sub_color);\n\n        .bi { font-size: 10px; }\n\n        &.is-small {\n            gap: 3px;\n            padding: 0 6px;\n            font-size: 9.5px;\n            line-height: 15px;\n\n            .bi { font-size: 9px; }\n        }\n    }\n\n    .ops-auto-mini-toggle {\n        width: fit-content;\n        display: flex;\n        align-items: center;\n        gap: 6px;\n        font-size: 11.5px;\n        color: var(--dark-color-dark);\n        cursor: pointer;\n\n        input { margin: 0; accent-color: var(--primary-color-main); cursor: pointer; }\n    }\n\n    .ops-spin { animation: ops-spin 1s linear infinite; }\n}\n\n@keyframes ops-spin {\n    to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
